// Product events to the influencer API's /metrics/events/create, through the cabinet's own client so a signed-in
// event carries its person: the Blazor app's MetricsService, same fields, same names.

import { cabinetApi } from './cabinet-api.ts';
import { deviceModel, getDeviceId, getDeviceInfo, getSessionId, osVersion } from './device.ts';

const APP = 'Influencer';
const PLATFORM = 'Web';
const APP_VERSION = '2.0.0';

/**
 * Fire and forget: never blocks the page and never fails it.
 * @param {string} type The MetricsType name in camelCase, e.g. "influencerDashboardViewed".
 * @param {Record<string, any>} [extras]
 */
export function track(type: string, extras?: Record<string, unknown>): void {
    const info = getDeviceInfo();

    cabinetApi('metrics/events/create', {
        method: 'POST',
        json: {
            type,
            deviceId: getDeviceId() || 'unknown',
            platform: PLATFORM,
            app: APP,
            sessionId: getSessionId(),
            appVersion: APP_VERSION,
            buildEnvironment: 'Release',
            deviceModel: deviceModel(info.userAgent),
            osVersion: osVersion(info.userAgent),
            timeZone: info.timeZone || 'Unknown',
            extras: extras || {}
        }
    }).catch(() => {
        // Never in the way.
    });
}
